export default __webpack_public_path__ + "static/media/Autonomous Rush.1c4a5e4f.png";